export default {
  setSelections(state, val) {
    state.selections = val.selections
  }
}



// WEBPACK FOOTER //
// ./src/Adm/UserAuthorization/store/mutations.js